import Marquee from "react-fast-marquee";

const phrases = ["Not prediction. Direction."];

export const EditorialMarquee = () => (
  <div className="py-8 sm:py-12 bg-[#FF4D0A] overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} autoFill>
      {phrases.map((p) => (
        <span key={p} className="flex items-center">
          <span className="h-heavy text-3xl sm:text-6xl text-[#0B0B0C] px-5 sm:px-6">
            {p}
          </span>
        </span>
      ))}
    </Marquee>
  </div>
);
